var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "advantages__container" }, [
    _c("div", { staticClass: "advantages__icon-box" }, [
      _c("img", { attrs: { src: _vm.image, alt: "Icon" } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "advantages__text-content" }, [
      _c("div", {
        staticClass: "advantages__headline",
        domProps: { innerHTML: _vm._s(_vm.headline) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "advantages__text",
        domProps: { innerHTML: _vm._s(_vm.text) }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }